import "../css/bootstrap@3.3.7.min.css";
import "../css/bootstrap-table@1.11.0.min.css";

import "../css/uploadform.css";
import "../css/panel.css";
import "../css/theme.css";
import "../css/compare.css";
import "../js/libs/json2";
import { make_jobid } from "../js/createjobid";
import { fileupload2 } from "../js/upload2";
import { run_compare } from "../js/run";
import { StateTable } from "../js/state_table";
import { check2 } from "../js/check";
import { update2 } from "../js/state_update";
import { ModelTable } from "../js/modeltable";
import { BtnToggler } from "../js/btnToggler";
import { scrollToAnchor } from "../js/scrollToAnchor";
import { UNLOCK_SUBMIT_EVT } from "../js/constants";
import arrowDown from "../img/advanced.png";
import arrowUp from "../img/advanced2.png";

$("header").load("./ajax/header.html");
$("footer").load("./ajax/footer.html");

var job;
var filename;
var id;
var timer;
//var count=0;
var json_str = [];
var row1 = {};
var fingerprint = "rpa";
var uid = checkcookies();
var textinputarray = [];
var lastorder = 0;
var initial = [];
var updateTimer;
ModelTable(initial, uid);

Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

function toggleOptions() {
  var isOpen = false;
  var newoptions = document.getElementById("newoptions");
  return function (e) {
    if (isOpen) {
      newoptions.style.display = "none";
      e.target.src = arrowDown;
    } else {
      newoptions.style.display = "block";
      e.target.src = arrowUp;
    }
    isOpen = !isOpen;
  };
}

$("#addoptions").on("click", toggleOptions());

function checkcookies() {
  var user = "";
  $.ajax({
    url: "./php/cookies.php",
    method: "post",
    data: {
      cname: fingerprint,
    },
    async: false,
    success: function (r1) {
      // console.log(r1);
      user = r1;
    },
    error: function (r1) {
      console.error(r1);
    },
  });
  StateTable(json_str);
  update2(user);
  return user;
}

function addfiles() {
  var unique = true;
  var testareafind = document.getElementById("textinput").value.trim();
  var modelNameInput = document.getElementById("textareaname");
  var textname = modelNameInput.value.trim();
  var tabledata = $("#modeltable").bootstrapTable("getData", false);
  // console.log(tabledata);
  //console.log(testareafind);
  if (tabledata.length != 0) {
    var tempname = textname.split(".")[0] + ".txt";
    for (var i = 0; i < tabledata.length; i++) {
      if (tabledata[i]["filename"] == tempname) {
        unique = false;
        break;
      } else {
        console.log(tabledata[i]["filename"] + " | " + textname);
      }
    }
  }
  if (unique) {
    if (testareafind == null || testareafind == "") {
      alert("Please input data in the text area!");
    } else if (textname == null || textname == "") {
      alert("Please name your input files");
    } else {
      if (!modelNameInput.checkValidity()) {
        alert("Invalid model name!");
        return;
      }
      var tablerow = document
        .getElementById("modeltable")
        .getElementsByTagName("button");
      var fileorder = tablerow.length + 1;
      if (fileorder <= lastorder) {
        fileorder = lastorder + 1;
      }
      lastorder = fileorder;
      var formername = textname.split(".")[0];
      input2(testareafind, fileorder, formername);
    }
  } else {
    alert(
      textname +
        " is already on the files list, please rename your input file or delete the former one"
    );
  }
}
$("#addfile").on("click", addfiles);

function input(targetfile, fileorder) {
  var target = "";
  var uppath = new Array();
  uppath = targetfile.split("\\");
  // console.log(targetfile);
  // console.log(uppath);
  var bar = $(".bar");
  var percent = $(".percent");
  var showimg = $("#showimg");
  var progress = $(".progress");
  var files = $(".files");
  var btn = $(".btn2 span");
  var action =
    "php/Fileupload2.php?filename=" + uppath[uppath.length - 1] + "&dir_name=";
  var jobid = uid;
  var uniquename = true;
  clear1();
  var namelist = document.getElementsByClassName("inputname");
  for (var i = 0; i < namelist.length; i++) {
    if (namelist[i].innerHTML == uppath[uppath.length - 1]) {
      uniquename = false;
      break;
    }
  }
  if (!uniquename) {
    // console.log('Find same');
    alert(
      "The " +
        uppath[uppath.length - 1] +
        " is already in the existed files list, Please rename it or delete the former one."
    );
  } else if (jobid != false) {
    console.log("Find unique");
    action = action + jobid + "/";
    fileupload2(bar, percent, showimg, progress, files, btn, action, fileorder);
    target = "compare/" + jobid + "/" + uppath[uppath.length - 1];
    // console.log(target);
    id = jobid;
    job = "compare/" + jobid + "/";
    filename = uppath[uppath.length - 1];
    //k=setInterval("circle('"+target+"',"+finish+")",5000);
    //circle("'"+target+"'",finish);
  }
}

function input2(content, fileorder, filename) {
  //var jobid = String($.trim(make_jobid()));
  filename = filename + ".rmd";
  var lists = document.getElementById("filelists");
  var jobid = uid;
  id = jobid;
  // console.log('path= ' + path);
  // console.log('dir= ' + dir);
  $.ajax({
    method: "post",
    url: "php/run_text2.php",
    data: "jobId=" + jobid + "&content=" + content + "&fileName=" + filename,
    // async: false,
    success: function (r1, r2, r3) {
      //console.log(r1);
      var filesize = r1;
      //var filename = document.getElementById("textareaname").value;
      var myDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      var currenttime = myDate.toString();
      var tableinput = [];
      var temp = {};
      temp["fileid"] = fileorder;
      temp["filename"] = filename;
      temp["filesize"] = filesize + "k";
      temp["uploadtime"] = currenttime;
      tableinput.push(temp);
      $("#modeltable").bootstrapTable("append", tableinput);
    },
    error: function (r1) {
      console.error("Fail to get example:", r1);
      //return "fail";
    },
  });
}

var $fileUpload = $("#fileupload");
$fileUpload.change(function () {
  var targetfile = document.getElementById("fileupload").value;
  var realname = targetfile.split("\\");
  var selectfile = document.getElementById("selectname");
  selectname.innerHTML =
    "<div style='width: 20px;display:inline;margin-top:20px;margin-left:10px;font-size:20px;' id='input_name'><b class='txet-success'><i class='glyphicon glyphicon-ok-circle' style='margin-top:10px;'>" +
    realname[realname.length - 1] +
    "</i></b></div>";
});

$("#addfile2").click(function () {
  var targetInput = document.getElementById("fileupload");
  var targetfile = targetInput.value;
  var tablerow = document
    .getElementById("modeltable")
    .getElementsByTagName("button");
  if (targetfile == null || targetfile == "") {
    alert("Please select the input file!");
  } else {
    var filename = targetInput.files[0].name;
    var filenameParts = filename.split(".");
    if (filenameParts.length > 1) {
      filenameParts.pop();
      filename = filenameParts.join(".");
    }
    var modelNameRegExp = /^\w+$/;
    var isValid = modelNameRegExp.test(filename);
    if (isValid) {
      input(targetfile, tablerow.length + 1);
    } else {
      alert(
        "Invalid filename! Only numbers, alphabets and underscore are allowed!"
      );
    }
  }
});

$("#clear_sequence").click(function () {
  clear1(); //$("#textinput").val('');
  clear2();
});

$("#load_exp1, #load_exp2").click(function (e) {
  var id = e.target.id,
    type,
    modelName;
  if (id === "load_exp1") {
    type = "compare1";
    modelName = "RPA";
  } else {
    type = "compare2";
    modelName = "AJCC";
  }
  showexample(type, modelName);
});

function showexample(type, modelName) {
  clear2();
  $.ajax({
    method: "post",
    url: "php/get_example.php",
    data: "type=" + type,
    // async: false,
    success: function (r1, r2, r3) {
      $("#textinput").val(r1);
      $("#textareaname").val(modelName);
    },
    error: function (r1) {
      console.error("Fail to get example:", r1);
      //return "fail";
    },
  });
  //document.getElementById("textinput").innerHTML=s;
}

function clear1() {
  $("#textinput").val("");
  $("#textareaname").val("");
}

function clear2() {
  $("#progress-bar").width("0%");
  $("#progress-percent").html("0%");
  $fileUpload.clearFields();
  $("#input_name").remove();
}

var submitToggler = new BtnToggler("#submit");
function calculate() {
  var tabledata = JSON.stringify(
    $("#modeltable").bootstrapTable("getData", false)
  );
  // console.log(tabledata);
  var tablegroup = $("#modeltable").bootstrapTable("getData", false);
  var namegroup = [];
  for (var i = 0; i < tablegroup.length; i++) {
    namegroup[i] = tablegroup[i]["filename"];
  }
  var namedata = JSON.stringify(namegroup);
  // console.log(namedata);
  var form = document.forms.form1;
  var timeIntervalInput = form.time_intervals;
  if (!timeIntervalInput.checkValidity()) {
    alert("Time period of survival rate must > 0!");
    return;
  }
  var timeintervals = timeIntervalInput.value;
  var timeUnit = $(form["time-unit"]).val();
  var jobid = String($.trim(make_jobid()));
  var bootstrap = form.bootstraptimes.value;
  // var email = form.email;
  var hc = form.HC.value;
  var hd = form.HD.value;
  var bal = form.BAL.value;
  var pve = form.PVE.value;
  // console.log(timeintervals);
  if (tablegroup.length < 2) {
    alert("Please submit at least 2 models for the property comparison");
  } else if (timeintervals == null || timeintervals == "") {
    alert("Please input the time intervals value!");
  } else if (isNaN(timeintervals)) {
    alert("Please input numerical variable in the time intervls");
  } else {
    submitToggler.lock("Submitting...");
    $(window).one(UNLOCK_SUBMIT_EVT, function () {
      submitToggler.unlock();
    });
    run_compare(
      uid,
      jobid,
      timeintervals,
      bootstrap,
      namedata,
      hc,
      hd,
      bal,
      pve,
      timeUnit,
      function () {
        check2(jobid, uid, function () {
          update2(uid);
        });
        scrollToAnchor("#task-records");
      }
    );
  }
}
$("#submit").on("click", calculate);
